module.exports = __webpack_public_path__ + "media/中年女-嘲讽笑1058.b65c0e90.wav";